import { useLocation } from 'react-router-dom';

import AccountSection from 'src/features/auth/AccountSection';
import ActionSheet, {
  ActionSheetDivider,
  ActionSheetItem,
} from 'src/shared/components/ui/ActionSheet';
import { isInside } from './navItems';
import type { NavItem } from './navTypes';

interface AccountSheetProps {
  isOpen: boolean;
  toggle: () => void;
  /** The phone's "Más": the screens that do not fit the bottom bar. */
  items?: NavItem[];
  title: string;
}

/**
 * "Más" on a phone (the other screens, then the account) and the account menu
 * elsewhere — the same sheet, with or without the screens.
 */
export default function AccountSheet({ isOpen, toggle, items = [], title }: AccountSheetProps) {
  const { pathname } = useLocation();

  return (
    <ActionSheet isOpen={isOpen} toggle={toggle} title={title}>
      {items.map((item) => (
        <ActionSheetItem
          key={item.to}
          icon={item.icon}
          label={item.label}
          hint={item.hint}
          to={item.to}
          active={isInside(pathname, item.to)}
          onClick={toggle}
        />
      ))}
      {items.length > 0 && <ActionSheetDivider />}
      <AccountSection onNavigate={toggle} />
    </ActionSheet>
  );
}
